<template>
  <UApp>
    <div class="h-full min-h-screen">
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </div>
  </UApp>
</template>

<script setup lang="ts">
import { h } from 'vue'
import type { ClientList } from '~/types/api/user/index.ts';

useState<ClientList>('selectedClient');
useState('selectedWebsite');
useState('selectedDomain');

const { appColorTheme } = useAppColorTheme()
useHead(() => ({
  htmlAttrs: {
    'data-app-theme': appColorThemeHtmlAttr(appColorTheme.value),
  },
}))

onMounted(() => {
  const toast = useToast()

  if(process.env.NODE_ENV === 'development'){
  const toastDevelopmentMessage = 
  `Environment: <b>${process.env.NODE_ENV}</b><br>
  "Fake production" is <b>${useRuntimeConfig().public.isDevelopment?'not turned on':'turned on'}</b>` // pragma: allowlist secret
  
  toast.add({
    id: 'is_development',
    title: 'Development Environment',
    description: h('div', { innerHTML: toastDevelopmentMessage }),
    icon: 'i-heroicons-computer-desktop',
    duration: 5000,
    ui: {
      // title: '!bg-red-500 text-red-500',
    },
  })
}

})



</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Honk&family=Nunito:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600&family=Roboto&display=swap');
  html, body, #__nuxt {
    height:100%;
    font-family: 'Nunito', sans-serif;
  }

  /* PageTransition */
  .slideIn-enter-active,
  .slideIn-leave-active {
    transition: all 0.3s;
  }

  .slideIn-enter-from,
  .slideIn-leave-to {
    opacity: 0;
    transform: translateX(-15px);
  }


</style>
